import http from "../utils/http";

export const getListFeedback = (params) => {
  return http.get("/customerFeedback", {
    params: params,
  });
};
export const getFeedback = (id) => {
  return http.get("/customerFeedback/" + id);
};

export const createFeedback = (entry) => {
  return http.post("/customerFeedback", { entry });
};

export const updateFeedback = (id, data) => {
  return http.put("/customerFeedback/" + id, {
    data,
  });
};

export const deleteFeedback = (id) => {
  return http.delete("/customerFeedback/" + id);
};
